import configs from '../config.js';
import { fetchWithTenant } from '../utils/apiClient';

const API_BASE_URL = `${configs.BACKEND_URL}/api/audit-logs`;

function buildQueryString(params = {}) {
  const filtered = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {});
  const qs = new URLSearchParams(filtered).toString();
  return qs ? `?${qs}` : '';
}

async function fetchJson(url, options) {
  const response = await fetchWithTenant(url, options);
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href = '/login';
    }
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || data.message || 'Request failed');
  }
  return response.json();
}

export const getAuditLogs = async (params = {}) => {
  return fetchJson(`${API_BASE_URL}/${buildQueryString(params)}`);
};

export const getAuditLogStats = async (params = {}) => {
  return fetchJson(`${API_BASE_URL}/stats${buildQueryString(params)}`);
};

export const getRecentActivity = async (limit = 10) => {
  return fetchJson(`${API_BASE_URL}/recent?limit=${limit}`);
};

export const exportAuditLogs = async (params = {}) => {
  const response = await fetchWithTenant(`${API_BASE_URL}/export${buildQueryString(params)}`);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to export audit logs');
  }
  return response.blob();
};

export const downloadAuditLogs = async (params = {}, filename) => {
  const blob = await exportAuditLogs(params);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || `audit-logs-${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const getAuditLogMetadata = async () => {
  return fetchJson(`${API_BASE_URL}/metadata`);
};

export const getUserAuditLogs = async (userEmail, additionalParams = {}) => {
  return getAuditLogs({ userEmail, ...additionalParams });
};

export const getModuleAuditLogs = async (module, additionalParams = {}) => {
  return getAuditLogs({ module, ...additionalParams });
};

export const getDateRangeAuditLogs = async (startDate, endDate, additionalParams = {}) => {
  return getAuditLogs({ startDate, endDate, ...additionalParams });
};

export const searchAuditLogs = async (searchTerm, additionalParams = {}) => {
  return getAuditLogs({ search: searchTerm, ...additionalParams });
};
